export default __webpack_public_path__ + "static/google_Desktop7-bc883087993a1d2e42a29a2776912849.svg";